import React, { FC } from 'react'
import styled from 'styled-components'

import { styleTheme } from '../../style/theme'

export const RequiredIcon: FC = () => {
  return <StyledIcon>必須</StyledIcon>
}

const StyledIcon = styled.div`
  color: ${styleTheme.colors.white};
  background-color: rgb(255, 87, 87);
  border-radius: 2px;
  font-size: 12px;
  font-weight: 500;
  padding: 2px 8px;
  height: fit-content;
  text-wrap: nowrap;
`
